import React from "react";
import {Navigate} from 'react-router-dom'
import {authToken} from "../ui-utils/general-variable";

export const PrivateRoute = ({ children }) => {
    const isAuthenticated = authToken

    return !!isAuthenticated ? children : <Navigate to="/" />
}